<template>
  <app-modal
		@close="$emit('close')"
	>
		<app-modal-default @close="$emit('close')">
			<template v-slot:header>
				{{ $ml.get(`Update payment method`) }}
			</template>
			<template v-slot:content>
        <PaymentMethod hide-card-variants @input="onPM"/>
        <app-btn :loading="loading" @click="updatePM">
          {{ $ml.get(`Save`) }}
        </app-btn>
			</template>
		</app-modal-default>
	</app-modal>
</template>

<script>
import PaymentMethod from '@/components/common/PaymentMethod';
import { ErrorHandlerMixin } from '@/mixins/error-handler.mixin';
import { UserAPI } from '@/api';
export default {
  mixins: [ ErrorHandlerMixin ],
  data() {
    return {
      pm: null,
      loading: false,
    }
  },
  methods: {

    onPM(pm) {
      this.pm = pm;
    },

    updatePM() {
      const init = async () => {
        try {
          const pm = await this.$env.stripe.createPaymentMethod(this.pm)
            .then(res => res.paymentMethod);

          await UserAPI.setPaymentMethod(pm.id);
        } catch (error) {
          this.handleErrorAsNotifications(error);
        }
      }

      this.loading = true;
      return init()
        .then(() => {
          this.$notify({
            group: 'notices',
            title: this.$ml.get(`Payment method successfully updated!`),
            type: 'success',
          });
          this.$emit('update');
          this.$emit('close');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  components: {
    PaymentMethod,
  }
}
</script>

<style lang="scss" scoped>

.app-btn {
  margin-top: 20px;
}

</style>
